/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [
  {
    action: 'createAccountSession',
    message: messages.SUCCESS_CREATE_ACCOUNT_SESSION,
    method: 'POST',
    path: '/account/session',
    payloadType: 'resource',
    permissionIdentity: null,
    requestSchema: requestSchemas.accountSessions.createAccountSession,
  },
  {
    action: 'deleteAccountSessions',
    message: messages.SUCCESS_DELETE_ACCOUNT_SESSIONS,
    method: 'DELETE',
    path: '/account/:accountId/sessions',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.DELETE_ACCOUNT_SESSION,
    requestSchema: requestSchemas.accountSessions.deleteAccountSessions,
  },
  {
    action: 'getAccountSessions',
    message: messages.SUCCESS_GET_ACCOUNT_SESSIONS,
    method: 'GET',
    path: '/account/:accountId/sessions',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_ACCOUNT_SESSION,
    requestSchema: requestSchemas.accountSessions.getAccountSessions,
    scopes: [scopes.DEFAULT],
  },
];
